import React, { useEffect, useState } from 'react';
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import SwapServiceView from './SwapServiceView';
import { useTranslation } from 'react-i18next';
import wsclients from '../../services/wsclients';

export default function SwapServiceController(props) {
    const { t } = useTranslation();
    const [selected, setSelected] = useState(null);
    const [listDates, setListDates] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});

    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]

    useEffect(() => {
        const dataOptions = [
            {
                label: 'BASE-PREPAID-R-20-10 (Recurring)',
                value: '1',
                child: renderChild(dates),
            },
            {
                label: 'BASE-PREPAID-O-20-10 (Non-Recurring)',
                value: '2',
            },
            {
                label: 'BASE-PREPAID-R-40-10 (Recurring)',
                value: '3',
                child: renderChild(dates),
            },
        ];
        console.log("dataOptions===", dataOptions);

        setOptions(dataOptions);
        setListDates(dates);
    }, []);

    const onChangeOption = (e) => {
        setSelected(e.target.value);
    }

    const onChangeDate = (e) => {
        setSelectedDate(e.target.value);
    }

    const renderChild = (items) => {
        return (
            <div style={{ marginLeft: 20 }}>
                {items && items.length > 0 &&
                    <CustomRadioButtonGroup
                        items={items}
                        selected={selectedDate ? selectedDate : null}
                        onChange={onChangeDate}
                    />
                }
            </div>
        );
    }

    const onValidate = () => {
        let valid = false;
        console.log("option selected===", selected);
        console.log("date selected===", selectedDate);
        if (selected) {
            if (selected === '2') {
                valid = true;
            } else if (!selectedDate) {
                setMessage({
                    show: true,
                    content: t('mess_warning')
                });
                valid = true;
            }
        } else {
            setMessage({
                show: true,
                content: t('mess_warning')
            });
            valid = true;
        }
        return valid;
    }

    const onProceed = async () => {
        onShowLoading(true);
        try {
            if (!onValidate()) {
                const result = await wsclients.lab4services.onUpgrade();
                console.log("result onUpgrade===", result);
                if (result.code === 'OK') {

                } else {
                    setMessage({
                        showAlert: true,
                        title: 'ERROR',
                        message: t('EXCEPTION_PROCESS'),
                        status: t('ERROR'),
                    });
                }
            }
        } catch (ex) {
            console.log("on onUpgrade ex:", ex);
        }
        onShowLoading(false);
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }
    return (
        <>
            <SwapServiceView
                options={options}
                selected={selected}
                listDates={listDates}
                selectedDate={selectedDate}
                onChangeOption={onChangeOption}
                onChangeDate={onChangeDate}
                onProceed={onProceed}
            />

            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={() => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}